import { useContext } from 'preact/hooks';

import ReferralContext from './contexts';

// eslint-disable-next-line import/prefer-default-export
export const useViralLoops = () => useContext(ReferralContext);
